import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { SaleAssociateService } from '../services/sale-associate.service';
import { AddSaleAssociateComponent } from './add-sale-associate/add-sale-associate.component';
import { EditSaleAssociateComponent } from './edit-sale-associate/edit-sale-associate.component';
import { ImportSaleAssociateComponent } from './import-sale-associate/import-sale-associate.component';

@Component({
  selector: 'app-sale-associate',
  templateUrl: './sale-associate.component.html',
  styleUrls: ['./sale-associate.component.css'],
})
export class SaleAssociateComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: AddSaleAssociateComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditSaleAssociateComponent;
  @ViewChild('pImport', { static: false }) pImport: ImportSaleAssociateComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: SaleAssociateService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      { field: 'salesAssociateCode', header: 'Mã CTV', visible: true, sort: false },
      { field: 'displayName', header: 'Họ và tên', visible: true, sort: true },
      { field: 'gender', header: 'Giới tính', visible: true, sort: true },
      { field: 'dateOfBirth', header: 'Ngày sinh', visible: true, sort: false },
      { field: 'phoneNumber', header: 'Số điện thoại', visible: true, sort: false },
      { field: 'unitCode', header: 'Đơn vị', visible: true, sort: false },
      { field: 'status', header: 'Trạng thái', visible: true, sort: false },
      { field: 'action', header: 'Hành động', visible: true, sort: false },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      unitCode: this.currentUser.unitCode,
      search: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };

    this._service
      .getListSalesAssociate(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editSaleAssociate(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }

  onAdd() {
    this.pCreate.showPopup();
  }

  onImport() {
    this.pImport.showPopup();
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
